<template>
  <div id="page-user-view">
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <div id="user-data">
      <!-- {{"Permissao adicionar "+canAddEmp}} -->
      <vx-card
        class="mb-base"
        title="Filtros">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label for="">Data inicial</label>
            <vs-input
              @change="getEmployees"
              class="w-full"
              icon-pack="feather"
              icon-no-border
              v-model="start_date"
              type="date"
              v-validate="'required'" />
          </div>
          <div>
            <label for="">Data de final</label>
            <vs-input
              @change="getEmployees"
              class="w-full"
              icon-pack="feather"
              icon-no-border
              v-model="end_date"
              type="date"
              v-validate="'required'" />
          </div>
          <div>
            <label for="">Pesquisar por</label>

            <select
              @change="getEmployees"
              v-model="search_parameter"
              class="block w-full pl-3 pr-10 py-3 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
              <option value="P">Presentes</option>
              <option value="NFA">Faltas injustificadas</option>
              <option value="FA">Faltas Justificadas</option>
              <option value="Delay">Atrasos</option>
              <option value="No_entry_date">Sem registo de entrada</option>
              <option value="No_exit_date">Sem registo de saida</option>
            </select>
          </div>

          <div>
            <label for=""></label> <br />
            <vs-button
              class="w-full"
              type="border"
              color="warning"
              @click="clean"
              >Limpar</vs-button
            >
          </div>
          <!-- <div class="vx-col w-1/6  mb-5" >
             <label for=""></label> <br>
              <vs-button  class="w-full" color="primary"  @click="saveMarcar">
                Marcar
              </vs-button>

          </div> -->
        </div>
        <!-- Avatar -->
      </vx-card>

      <vx-card title="">
        <vs-divider></vs-divider>
        <div class="block overflow-x-auto">
          <vs-table
            stripe
            v-model="selected"
            :max-items="paginate"
            search
            :data="employees">
            <template slot="header">
              <select
                @change="getEmployees"
                class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                v-validate="'excluded:1,2,3'"
                v-model="paginate"
                name="not_in_field"
                data-vv-as="selected">
                <option
                  class="vs__selected-options"
                  value="5">
                  5
                </option>
                <option
                  class="vs__selected-options"
                  value="10">
                  10
                </option>
                <option
                  class="vs__selected-options"
                  value="15">
                  20
                </option>
                <option
                  class="vs__selected-options"
                  value="50">
                  50
                </option>
                <option
                  class="vs__selected-options"
                  value="100">
                  100
                </option>
                <option
                  class="vs__selected-options"
                  value="500">
                  500
                </option>
                <option
                  class="vs__selected-options"
                  value="1000">
                  1000
                </option>
              </select>
              <label class="ml-3 font-bold">Total: {{ total }}</label>
            </template>
            <template slot="thead">
              <vs-th sort-key="code">Codigo</vs-th>
              <vs-th sort-key="name">Nome</vs-th>
              <vs-th sort-key="surname">Apelido</vs-th>
              <vs-th sort-key="entry_date">
                <span v-if="search_parameter == 'P'">Presenças </span>
                <span v-if="search_parameter == 'NFA'"
                  >Faltas injustificadas
                </span>
                <span v-if="search_parameter == 'FA'"
                  >Faltas Justificadas
                </span>
                <span v-if="search_parameter == 'Delay'">Atrasos </span>
                <span v-if="search_parameter == 'No_entry_date'"
                  >Sem registo de entrada
                </span>
                <span v-if="search_parameter == 'No_exit_date'"
                  >Sem registo de saida
                </span>
                <span class="ml-1">(total)</span>
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].code">
                  {{ data[indextr].code }}
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].surname">
                  {{ data[indextr].surname }}
                </vs-td>

                <vs-td
                  v-if="search_parameter != 'Delay'"
                  :data="data[indextr].count">
                  {{ data[indextr].count }}
                </vs-td>
                <vs-td v-if="search_parameter == 'Delay'">
                  {{ secondsToHms(data[indextr].count) }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div
            style="height: 50px"
            id="div-with-loading"
            class="vs-con-loading__container"></div>
          <vs-pagination
            class="mt-3"
            :total="totalPage"
            @change="getEmployees"
            v-model="currentPage"></vs-pagination>
          <!-- <pre> {{ selected }} </pre> -->
        </div>
        <div class="vx-row">
          <!-- <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto  mt-2" type="border" color="warning"  @click="clean">Limpar</vs-button>
          <vs-button class="ml-4 mt-2" @click="saveMarcar" >Marcar</vs-button>
        </div>
      </div> -->
        </div>
      </vx-card>
    </div>

    <vs-popup
      class="holamundo"
      title="Justificar Falta"
      :active.sync="popupJustificar">
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <label for="">Motivo</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="description"
            type="text"
            v-validate="'required'" />
        </div>

        <div class="vx-col w-full mb-5">
          <label for="">Comprovativo</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            name="file"
            type="file"
            v-validate="'required'"
            @change="previewImage"
            accept="image/*" />
        </div>
      </div>

      <div class="flex flex-wrap items-end flex-start">
        <vs-button
          class="ml-auto mt-2"
          @click="saveJustificar"
          >Justificar</vs-button
        >
        <vs-button
          class="ml-4 mt-2"
          type="border"
          color="warning"
          >Cancelar</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import http from '../../../../http-common';
  import vSelect from 'vue-select';
  export default {
    components: {
      vSelect
    },
    data() {
      return {
        start_date: '',
        end_date: '',
        search_parameter: 'Delay',

        note: '',
        totalPage: '',
        currentPage: '',
        paginate: 15,

        dataEntrada: '',
        dataSaida: '',
        estado: '',
        users: [],
        selectedUser: '',
        permission_name: [],
        role_name: [],
        popupJustificar: false,
        err: '',
        employees: [],
        popupUpBaixar: false,
        exit_date: '',
        exit_time: '',

        result: [],
        employee_id: [],
        attendance_id: [],
        entry_date: '',
        note: '',
        attachment: '',
        falta: [],
        description: '',
        search_parameter: ''
      };
    },

    mounted() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.getEmployees();
      },

      clean() {
        (this.search_parameter = ''),
          (this.start_date = ''),
          (this.end_date = ''),
          this.getEmployees();
      },

      mapear() {
        this.result = this.selected.map(person => person.attendance_id);
      },

      previewImage(event) {
        this.attachment = event.target.files[0];
      },

      secondsToHms(seconds) {
        var hours = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds % 3600) / 60);
        var seconds = Math.floor(seconds % 60);
        return hours + 'h ' + minutes + 'm ' + seconds + 's';
      },

      getEmployees() {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 1.0,
          type: 'sound'
        });

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            start_date: this.start_date,
            end_date: this.end_date,
            search_parameter: this.search_parameter
          }
        };

        http
          .get('/reports/attendanceReport', config)
          .then(result => {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
            this.employees = result.data.Report;

            // this.totalPage = result.data.Attendances.last_page;
            // this.total =  result.data.Attendances.total;
            // alert("2")
          })
          .catch(error => {
            error;
            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      }
    }
  };
</script>

<style lang="scss">
  #avatar-col {
    width: 10rem;
  }

  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: 0.8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
    only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }

    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;

    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  }
</style>
